import React from "react";

import { ReactComponent as CloseIcon } from "../../../../assets/svg/close.svg";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/arrow_right.svg";
import { ReactComponent as QuestionIcon } from "../../../../assets/svg/questionmark_green.svg";
import { ITeacherSurvey } from "../../../../state";
import { WELCOME_MESSAGE } from "../../../../constants/teaching_hint";

import styles from "./Welcome.module.scss";

type Props = {
  onClose: () => void;
  onNext: () => void;
  onTooltip: () => void;
  teacherSurvey: ITeacherSurvey | null;
};

type SurveyStatus = keyof typeof WELCOME_MESSAGE;

const Welcome: React.FC<Props> = ({
  onClose,
  onNext,
  onTooltip,
  teacherSurvey,
}) => {
  const surveyStatus: SurveyStatus =
    teacherSurvey !== null ? "surveyAnswered" : "surveyNotAnswered";
  const { title, text } = WELCOME_MESSAGE[surveyStatus];

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.headerText}>{title}</h1>
        <button className={styles.closeButton}>
          <CloseIcon onClick={onClose} />
        </button>
      </div>
      <div className={styles.content}>
        <p>{text}</p>
        <div className={styles.buttonContainer}>
          <button className={styles.hint} onClick={onTooltip}>
            <QuestionIcon />
            PICOとは?
          </button>
          <button onClick={onNext} className={styles.submit}>
            {teacherSurvey ? "情報を更新する" : "情報を入力する"}
            <RightArrowIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
